<template>
  <nuttrema-layout-content>

    <template slot="header">
      <stuff-to-eat-standard-header
        :edit.sync="edit"
        :meta="meta"
        :StuffToEatDetails="StuffToEatDetails">
        <template slot="edit">
          <div class="content-header-item">
            <permissions-control-wrapper
               action="label.edit"
              :required-general="$PERMISSIONS_GENERAL.DELETE"
              :permissions="_get(StuffToEatDetails, 'meta.permissions')">
              <el-button
                 slot="allowed"
                 size="mini"
                :type="edit ? 'nuttrema-orange' : ''"
                @click="edit = !edit">
                {{ $t('label.edit') }}
              </el-button>

              <el-button
                slot="not-allowed"
                size="mini"
                type="info"
                class="is-icon-mr-075">
                <i class="far fa-lock-alt"></i>{{ $t('label.edit') }}
              </el-button>
            </permissions-control-wrapper>
          </div>
        </template>
      </stuff-to-eat-standard-header>
    </template>

    <template slot="central">
      <form-stuff-to-eat-delete
        :id="id"
        :edit.sync="edit"
        :StuffToEatDetails="StuffToEatDetails"
        @delete="onDelete">
      </form-stuff-to-eat-delete>
    </template>
  </nuttrema-layout-content>
</template>

<script>
import { mapActions } from 'vuex';

import PageProps from 'components/mixins/page-props';

import NuttremaLayoutContent from 'components/ui/layout/nuttrema-layout-content';
import StuffToEatStandardHeader from 'components/pages/professional/stuff-to-eat/shared/blocks/cmpt-stuff-to-eat-standard-header';

import FormStuffToEatDelete from './form-stuff-to-eat-delete';

export default {
  name: 'page-program-delete',
  mixins: [
    PageProps,
  ],
  props: {
    id: {
      required: false,
      default: null,
    },
    type: {
      required: true,
      default: null,
    },
  },
  data() {
    return {
      edit: false,
    };
  },
  components: {
    FormStuffToEatDelete,
    NuttremaLayoutContent,
    StuffToEatStandardHeader,
  },
  computed: {
    StuffToEatDetails() {
      return this.$store.getters.StuffToEatDetails(this.id);
    },
  },
  methods: {
    ...mapActions([
      'DeleteStuffToEat',
    ]),
    onDelete() {
      this.DeleteStuffToEat({ id: this.id, type: this.type }).then(() => {
        this.successNotification({ label: 'label.item', message: 'message.default_success_delete_message' });
        this.onSuccessEvent();
      }).catch((error) => {
        console.error(error);
        this.errorNotification({ message: 'message.default_error_delete_message' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/delete/page-stuff-to-eat-delete.vue